import { useState, useEffect, useRef } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input.jsx';
import { ValitatePaymentsTable } from '../../common/Tables/Tables.jsx';
import { validatePaymentsTableHeader } from '../../../assets/helpers/tables.js';
import { notify } from '../../../assets/helpers/toast.js';
import { salesRoles } from '../../../assets/helpers/roles.js';
import {
  FilterDatePicker,
} from '../../common/Forms/Input/Input.jsx';
import moment from 'moment';
import { filterParams } from '../../../assets/helpers/funciones.js';
import './ValidatePayments.scss';
import authService from '../../../services/authService.js';
import { paymentsService } from '../../../services/paymentsService.js';
import { ValidatePaymentModal } from '../../common/Modals/Modals.jsx';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];

export const ValidatePayments = () => {
  const tableRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [validatePaymentModal, setValidatePaymentModal] = useState({
    isOpen: false,
    id: '',
  });
  const [linkedMemberships, setLinkedMemberships] = useState([]);
  const [dateFrom, setDateFrom] = useState(
    new Date(moment().subtract(1, 'months'))
  );
  const [dateTo, setDateTo] = useState(new Date(moment()));
  const [validatePaymentTable, setValidatePaymentTable] = useState({
    limit: itemsPerpage[2],
    offset: 0,
    data: [],
    count: 0,
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
  });

  const setFirstPage = () => {
    setValidatePaymentTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setDateTo(e);
      setFirstPage();
    }
  };

  const selectitemsPerpage = (event) => {
    setValidatePaymentTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setValidatePaymentTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * validatePaymentTable?.limit,
      };
    });
  };

  const checkLinkedMemberships = async (payment) => {
    try {
      setIsLoading(true);
      const response = await paymentsService.checkLinkedPayments({
        payments: [
          {
            method: payment?.methodId,
            reference: payment?.reference,
          },
        ],
      });
      if (response.status === 200) {
        const memberships = response?.data?.memberships || [];
        const membershipIds = memberships.map((m) => m?.membershipId);
        setLinkedMemberships(membershipIds);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      return [];
    }
  };

  // const handleSearchChange = (event) => {
  //   setValidatePaymentTable((prevState) => {
  //     return {
  //       ...prevState,
  //       searchParam: event?.target?.value,
  //       page: 1,
  //       offset: 0,
  //       data: false,
  //     };
  //   });
  // };

  const validatePaymentAction = (id) => {
    if (!id) {
      notify('No se ha encontrado el pago', 'error');
      return;
    }
    if (!isLoading) {
      setIsLoading(true);
      paymentsService
        .validatePayment({ id: id })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Pago validado`, 'success');
            getUncheckedPayments();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {});
    }
  };

  const handleOpenModal = async (payment) => {
    await checkLinkedMemberships(payment);
    setValidatePaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !prevState.isOpen,
        id: payment?._id,
      };
    });
  };

  const handleCloseModal = () => {
    setLinkedMemberships([]);
    setValidatePaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: false,
        id: '',
      };
    });
  };

  useEffect(() => {
    // getMembershipCashea();
    getUncheckedPayments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    validatePaymentTable?.page,
    validatePaymentTable?.offset,
    validatePaymentTable?.limit,
    validatePaymentTable?.type,
    dateFrom,
    dateTo,
  ]);

  const getUncheckedPayments = () => {
    let params = {
      dateFrom: dateFrom
        ? moment(dateFrom).format('MM-DD-YYYY')
        : moment().subtract(1, 'months').format('MM-DD-YYYY'),
      dateTo: dateTo
        ? moment(dateTo).format('MM-DD-YYYY')
        : moment().format('MM-DD-YYYY'),
      limit: validatePaymentTable?.limit,
      offset: validatePaymentTable?.offset,
      searchParam: validatePaymentTable?.searchParam,
    };

    paymentsService
      .listUncheckedPayments(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setValidatePaymentTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.payments,
              count: response?.data?.total,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || 'error', 'error');
          setValidatePaymentTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setValidatePaymentTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <ValidatePaymentModal
        linkedMemberships={linkedMemberships}
        isOpen={validatePaymentModal?.isOpen}
        id={validatePaymentModal?.id}
        handleModal={handleCloseModal}
        action={validatePaymentAction}
      />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">{`Validación de Pagos: ${validatePaymentTable.count}`}</h1>
        </div>
        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              {/* <div className="col-12 col-md-2" style={{ marginTop: '30px' }}>
                <SearchInput
                  placeholder={'Nombre o Apellido, Cédula o Placa'}
                  searchAction={getUncheckedPayments}
                  value={validatePaymentTable?.searchParam}
                  onChange={handleSearchChange}
                  width="50px"
                />
              </div> */}
              {![
                salesRoles?.SALES_HUNTER,
                salesRoles?.SALES_COUNTER,
                salesRoles?.SALES_FARMER,
                salesRoles?.SALES_ADMIN_AUX,
                salesRoles?.SALES_KEY_ACCOUNTS,
              ].includes(authService?.getUserType()) ? (
                <>
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Desde'}
                    type={'date'}
                    name={'dateFrom'}
                    placeholder={''}
                    onChange={handleSinceDateChange}
                    value={dateFrom}
                    disabled={validatePaymentTable?.isLoading}
                  />
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Hasta'}
                    type={'date'}
                    name={'dateTo'}
                    placeholder={''}
                    onChange={handleUntilDateChange}
                    value={dateTo}
                    disabled={validatePaymentTable?.isLoading}
                  />
                </>
              ) : null}
              <div
                style={{
                  marginTop: '24px',
                  marginLeft: 'auto',
                  width: '350px',
                }}
              >
                {![
                  salesRoles?.SALES_FARMER,
                  salesRoles?.SALES_HUNTER,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_ADMIN_AUX,
                  salesRoles?.SALES_KEY_ACCOUNTS,
                ].includes(authService?.getUserType()) && (
                  <SelectPerPage
                    label={'Registros por página'}
                    options={itemsPerpage}
                    value={validatePaymentTable?.limit}
                    onChange={selectitemsPerpage}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ValitatePaymentsTable
          header={validatePaymentsTableHeader}
          data={validatePaymentTable}
          handlePageChange={handlePageChange}
          tableRef={tableRef}
          dateFrom={dateFrom}
          dateTo={dateTo}
          action={handleOpenModal}
        />
      </div>
    </>
  );
};
